import identity from '@/locales/en/identity/identity.locales';
import roles from '@/locales/en/identity/roles.locales';

export default {
    ...roles,
    ...identity,
};
